import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './md-w4.component.html';
import { SignaturePadModal } from '../signature/signature-pad.component';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const MdW4Component = {
    templateUrl,
    controller: MdW4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        ownerInfo: "<",
        stateTaxInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
}

function MdW4Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $uibModal, $q, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';
    vm.taxForm;
    const MD_STATE_ID = 22;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onShowI9 = onShowI9;
    vm.onRequestReview = onRequestReview;
    vm.onSign = onSign;
    vm.onSave = onSave;
    vm.syncFormToProfile = syncFormToProfile;
    vm.onExemptChange = onExemptChange;
    vm.onStep3Toggle = onStep3Toggle;
    vm.onAbToggle = onAbToggle;
    vm.syncStateDots = syncStateDots;
    vm.onChangeLegalResident = onChangeLegalResident;
    vm.autofillZero = autofillZero;
    vm.mdExemptClaimed = mdExemptClaimed;
    vm.onEditClicked = onEditClicked;
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ssnIsValidated = ssnIsValidated;
    vm.ssnBlur = ssnBlur;
    vm.formatSsn = formatSsn;
    vm.onClose = onClose;

    vm.reqReview = false;
    vm.isSigned = false;
    vm.isSaved = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.disableEmpFields = true;
    vm.savedData = false;
    vm.showSavedNotification = false;
    vm.previewUrl;
    vm.isExempt = false;
    vm.stateWitholdingTypeID = 5;

    // MW507 marital status (single text/radio field). Values written to the PDF marital-status field.
    vm.maritalStatusOptions = [
        { value: 'S', label: 'Single' },
        { value: 'M', label: 'Married (surviving spouse or unmarried Head of Household) rate' },
        { value: 'MS', label: 'Married, but withhold at Single rate' }
    ];
    // MD marital value -> DB dbo.MaritalStatus.MaritalStatusID (1=Single, 2=Married). CONFIRM ids.
    vm.maritalStatusMapping = [
        { value: 'S', id: 4, label: 'Single' },
        { value: 'M', id: 5, label: 'Married (surviving spouse or unmarried Head of Household) rate' },
        { value: 'MS', id: 12, label: 'Married, but withhold at Single rate' }
    ];

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;

        vm.retrieveLocale()
            .then(function (locale) {
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });

        if (vm.savedInputs != null && vm.savedInputs.FullName != null && !vm.ownerView) {
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            prefillFromProfile();
        } else if (vm.userInputs != null && vm.userInputs.FullName != null) {
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
        } else {
            prefillFromProfile();
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        vm.editable = resolveEditable();
        prefillEmployer();
        utilityService.hideLoading();
        if (vm.ownerView && vm.showSignaturePopup) {
            return onPreview();
        }
    }

    function prefillFromProfile() {
        vm.employeeName = [vm.employeeProfile.FirstName, vm.employeeProfile.MiddleName, vm.employeeProfile.LastName].filter(Boolean).join(' ');
        vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
        let stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID)
        vm.address = [vm.profile.HomeAddress?.StreetLine1, vm.profile.HomeAddress?.StreetLine2, vm.profile.HomeAddress?.AptNum, vm.profile.HomeAddress?.City, stateProvince.Abbr, vm.profile.HomeAddress?.PostalCode].filter(Boolean).join(', ');
    }

    function prefillEmployer() {
        if (vm.employerNameAddress) {
            return;
        }
        if (vm.ownerInfo) {
            if (vm.ownerInfo.ShippingAddress) {
                const a = vm.ownerInfo.ShippingAddress;
                vm.employerNameAddress = [vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName, a.StreetLine1, a.StreetLine2, a.AptNum, a.City, a.StateName, a.PostalCode, a.CountryName].filter(Boolean).join(', ');
            } else {
                vm.employerNameAddress = [vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName].filter(Boolean).join(', ');
            }
            if (!vm.employerFein) {
                vm.employerFein = vm.ownerInfo.FEIN;
            }
        } else if (vm.owner) {
            vm.employerNameAddress = [vm.owner.LegalBusinessName || vm.owner.ClientName].filter(Boolean).join(', ');
        }
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }
        return !vm.application.HasSW4Form || formStatus === 'Pending' || formStatus === 'ReviewRequired';
    }

    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            prefillFromProfile();
        }
    }

    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    function onSign() {
        return $uibModal.open({
            ...SignaturePadModal,
            resolve: { title: () => "Signature" }
        }).result.then(function (data) {
            vm.signimage = data;
        });
    }

    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm && vm.taxForm.$dirty) {
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => "Your form is not completed yet. Do you want to leave?",
                    state: () => "application-status"
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onShowFederalW4() {
        if (vm.ownerView) {
            return $state.go('application-status.ownermodal.federalW4');
        }
        if (vm.taxForm && vm.taxForm.$dirty) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => "Your form is not completed yet. Do you want to leave?",
                    state: () => "onboarding-document.federalW4"
                },
                size: 'sm',
                backdrop: 'static'
            }).result
        }
        return $state.go('onboarding-document.federalW4');
    }

    function toNumOrNull(v) {
        if (v === null || v === undefined || v === "") {
            return null;
        }
        const n = Number(v);
        return isNaN(n) ? null : n;
    }

    function fillEmployee(application) {
        const isEx = function (v) {
            return v === "EXEMPT";
        };
        vm.employeeName = application.FullName;
        vm.employeeSsn = application.EmployeeSocialSecurityNumber;
        vm.address = application.HomeAddress;
        vm.residenceCounty = application.ResidenceCounty;
        vm.maritalStatusValue = application.MaritalStatus;
        vm.totalExemptions = toNumOrNull(application.TotalExemptions);
        vm.additionalWithholding = toNumOrNull(application.AdditionalWithholding);
        vm.exempt = application.Exempt === 'yes';
        vm.exempt2 = application.Exempt2 === 'yes';
        vm.applicableYear = application.ApplicableYear;
        vm.exemptText1 = isEx(application.ExemptText1);
        vm.exemptText2 = isEx(application.ExemptText2);
        vm.exemptText3 = isEx(application.ExemptText3);
        vm.exemptText4 = isEx(application.ExemptText4);
        vm.exemptText5 = isEx(application.ExemptText5);
        vm.exemptText6 = isEx(application.ExemptText6);
        vm.legalResidentState = application.LegalResident;
        vm.legalResidentOption = (vm.stateProvinces || []).find(function (s) {
            return s.Abbr === application.LegalResident;
        }) || null;
        vm.domicileState = application.Columbia === 'columbia' ? 'DC'
            : application.Virginia === 'columbia' ? 'VA'
                : application.WestVirginia === 'West Virginia' ? 'WV'
                    : null;
        vm.employerNameAddress = application.EmployerNameAddress;
        vm.employerFein = application.EmployerfederalEIN;
        if (application.Date) {
            vm.date = moment(application.Date, "MM/DD/YYYY").toDate();
        }
        if (application.Signature) {
            vm.signimage = application.Signature;
            vm.isSigned = true;
        }
        vm.prefilled = true;
    }


    function buildFormData() {
        const ex = function (b) {
            return b ? "EXEMPT" : "";
        };
        const data = {
            RequestTypeId: "2",
            IsI9EmployeeMode: !vm.ownerView,
            FullName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            HomeAddress: vm.address,
            ResidenceCounty: vm.residenceCounty,
            MaritalStatus: vm.maritalStatusValue,
            // Steps 1-2: numbers, autofill 0 when blank
            TotalExemptions: (vm.totalExemptions == null || vm.totalExemptions === "") ? 0 : vm.totalExemptions,
            AdditionalWithholding: (vm.additionalWithholding == null || vm.additionalWithholding === "") ? 0 : vm.additionalWithholding,
            // Exemption checkboxes: write literal EXEMPT when checked, blank otherwise (no autofill)
            Exempt: vm.exempt ? 'yes' : 'Off',
            Exempt2: vm.exempt2 ? 'yes' : 'Off',
            ApplicableYear: vm.applicableYear,
            ExemptText1: ex(vm.exemptText1),
            ExemptText2: ex(vm.exemptText2),
            ExemptText3: ex(vm.exemptText3),
            ExemptText4: ex(vm.exemptText4),
            ExemptText5: ex(vm.exemptText5),
            ExemptText6: ex(vm.exemptText6),
            LegalResident: vm.legalResidentState,
            // DC/VA/WV dots -> the picked one gets EXEMPT, others blank
            Columbia: vm.domicileState === 'DC' ? 'columbia' : 'Off',
            Virginia: vm.domicileState === 'VA' ? 'columbia' : 'Off',
            WestVirginia: vm.domicileState === 'WV' ? 'West Virginia' : 'Off',
            EmployerNameAddress: vm.employerNameAddress,
            EmployerfederalEIN: vm.employerFein,
            Date: moment(vm.date, "MM/DD/YYYY").format("MM/DD/YYYY"),
            Signature: vm.signimage,
        };
        Object.keys(data).forEach(function (k) {
            if (k === "IsI9EmployeeMode") {
                return;
            }
            data[k] = (data[k] === null || data[k] === undefined) ? "" : String(data[k]);
        });
        return data;
    }


    function onExemptChange() {
        // MW507: exemption boxes do not clear/autofill other fields. Kept as a no-op hook.
    }

    // Step 3 hierarchy: a/b only selectable when 3 is checked; unchecking 3 clears a/b and the year.
    function onStep3Toggle() {
        if (!vm.exemptText1) {
            vm.exempt = false;
            vm.exempt2 = false;
            vm.applicableYear = null;
        }
    }

    // Applicable year applies only when BOTH a and b are checked; otherwise clear it.
    function onAbToggle() {
        if (!(vm.exempt && vm.exempt2)) {
            vm.applicableYear = null;
        }
    }

    // Step 4 state dots (DC/VA/WV) apply only when 4 is checked and neither 6 nor 7 is claimed; clear them otherwise.
    function syncStateDots() {
        if (!vm.exemptText2 || vm.exemptText4 || vm.exemptText5) {
            vm.domicileState = null;
        }
    }

    // Kendo combo-box holds the selected state object; mirror its Abbr into the form-validated hidden input (mirrors user-profile Gender pattern).
    function onChangeLegalResident() {
        vm.legalResidentState = (vm.legalResidentOption != null) ? vm.legalResidentOption.Abbr : null;
    }

    // Steps 1-2 numbers: autofill 0 when left blank.
    function autofillZero(prop) {
        if (vm[prop] == null || vm[prop] === "") {
            vm[prop] = 0;
        }
    }

    // True when the employee is claiming any exemption on the form.
    function mdExemptClaimed() {
        return !!(vm.exempt || vm.exempt2 || vm.exemptText1 || vm.exemptText2 || vm.exemptText3
            || vm.exemptText4 || vm.exemptText5 || vm.exemptText6 || vm.legalResidentState);
    }


    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', String(MD_STATE_ID), pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });
    }

    function onPreview() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        const formData = buildFormData();
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, MD_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "State W4 - Maryland Preview",
                        previewUrl: () => vm.previewUrl,
                        allowApprove: () => canApproveForm(vm.application, '2'),
                        allowSign: () => false,
                        showSignaturePopup: () => vm.showSignaturePopup
                    }
                }).result
            }).then(function (data) {
                if (data && data.success) {
                    vm.employerSignimage = data.dataUrl;
                    vm.isSigned = true;
                    return onSubmit();
                }
            }).catch((err) => {
                utilityService.hideLoading();
                alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
            });
    }

    function onPreviewInPage() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        const formData = buildFormData();
        formData.Signature = undefined;
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, MD_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "State W4 - Maryland Preview",
                        previewUrl: () => vm.previewUrl
                    }
                }).result
            }).then(function (data) {
                if (!data || !data.dataUrl) {
                    utilityService.hideLoading();
                    return;
                }
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                return onSubmit();
            }).catch((err) => {
                utilityService.hideLoading();
                if (err === 'cancel' || err === 'backdrop click' || err === 'escape key press' || err === undefined) {
                    return;
                }
                alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
            });
    }

    function onSave() {
        utilityService.showLoading();
        const formData = buildFormData();
        return onboardingDocumentService.save(vm.employee.UserName, formData, MD_STATE_ID).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        });
    }

    function onApprove() {
        const approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    function syncFormToProfile() {
        const mapped = vm.maritalStatusMapping.find(function (x) {
            return x.value === vm.maritalStatusValue;
        });
        const mappedId = mapped ? mapped.id : null;
        if (mappedId != null && Array.isArray(vm.maritalStatus)) {
            const match = vm.maritalStatus.find(function (item) {
                return item.MaritalStatusID === mappedId;
            });
            if (match) {
                vm.employeeBankInfo.StateMaritalStatusID = match.MaritalStatusID;
                // Z: State Marital Status text (Column Z) <- selected marital label
                vm.employeeBankInfo.StateMaritalStatusParams = vm.residenceCounty + ',' + mapped.label;
            }
        }
        vm.employeeBankInfo.RegularWithholdingAllowances = toNumOrNull(vm.totalExemptions) || 0;
        const stateAmt = toNumOrNull(vm.additionalWithholding) || 0;
        vm.employeeBankInfo.EmployeeWithholdingInfos = (vm.employeeBankInfo.EmployeeWithholdingInfos || []).filter(function (x) {
            return x.WithholdingTypeID !== vm.stateWitholdingTypeID;
        });
        if (stateAmt > 0) {
            vm.employeeBankInfo.EmployeeWithholdingInfos.push({ EmployeeId: vm.employee.EmployeeID, WithholdingTypeID: vm.stateWitholdingTypeID, AdditionalWithholdingAmount: stateAmt });
        }
        // Column AF (State Exempt): true if exemption claimed on Line 3, 4, 5, or 8 (not local-PA lines 6/7).
        vm.employeeBankInfo.StateTaxExempt = !!(vm.exemptText1 || vm.exemptText2 || vm.exemptText3 || vm.exemptText6);
    }

    function onSubmit() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return utilityService.hideLoading();
        }
        const updatePromises = [];
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
                return;
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            const formData = buildFormData();
            if (!vm.ownerView) {
                syncFormToProfile();
                updatePromises.push(() => employeeService.updateEmployeeOnboardingBankInfo(vm.employee.EmployeeID, vm.employeeBankInfo));
            }
            updatePromises.push(() => onboardingDocumentService.submit(vm.employee.UserName, formData, MD_STATE_ID));
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }
        const trans = updatePromises.reduce((chain, promise) => {
            return chain.then(() => (typeof promise === 'function' ? promise() : promise));
        }, $q.resolve()).then((res) => {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID).then(function (translations) {
            return translations;
        });
    }
    function retrieveLocale() {
        return localeService.retrieveLocales().then(function (locales) {
            return locales.filter(function (locale) {
                return locale.countryID === vm.employeeBankInfo.CountryID;
            })[0] || localeService.retrieveCurrentLocale();
        }).then(function (locale) {
            if (locale) {
                return locale;
            }
        });
    }
    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }
    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function formatSsn(ssn) {
        if (!ssn) return "";
        var digits = ("" + ssn).replace(/[^0-9]/g, "");
        if (digits.length !== 9) return ssn;
        var mask = vm.employeeBankInfo
            && vm.employeeBankInfo.Translations
            && vm.employeeBankInfo.Translations.SSNMask;
        if (mask === "000-000-000") {
            return digits.slice(0, 3) + "-" + digits.slice(3, 6) + "-" + digits.slice(6, 9);
        }
        return digits.slice(0, 3) + "-" + digits.slice(3, 5) + "-" + digits.slice(5, 9);
    }
    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}

export const MDW4Modal = {
    component: "apexMDW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
